import { flow } from "fp-ts/lib/function";

import { type MetricField } from "../../../gql-generated/types";
import { parseIntWithCurrentValue } from "../../math";
import { type DimensionFunnel, isMapEmptyLens, makeFunnelItemLens, valueLens } from "../../models/dimension-funnel";

import {
    setFunnelItemFractionPercent,
    setFunnelItemFractionsPercentFormatted,
    setFunnelItemLabel,
    setFunnelItemLabelPrevious,
    setFunnelItemValueFormatted,
} from "./dimensionBreakdownFunnelModifiers";

export const modifyDimensionFunnelItem = (
    dimensionFunnel: DimensionFunnel,
    dimensionBreakdownKey: string,
    fieldName: MetricField,
    previousMetricField: MetricField | null,
    firstMetricField: MetricField | null,
    value: string,
    isMapEmpty = true,
    isNotEnough?: boolean,
): DimensionFunnel => {
    const funnelItemLens = makeFunnelItemLens(dimensionBreakdownKey, fieldName);

    const previousMetricValue = previousMetricField
        ? dimensionFunnel[dimensionBreakdownKey]?.[previousMetricField]?.value ?? null
        : null;

    const firstMetricValue = firstMetricField
        ? dimensionFunnel[dimensionBreakdownKey]?.[firstMetricField]?.value ?? null
        : null;

    return funnelItemLens.modify(
        // TODO(kkold) - Fix optionals
        flow(
            (funnelItem) => (funnelItem ? valueLens.modify(parseIntWithCurrentValue(value))(funnelItem) : funnelItem),
            (funnelItem) => (funnelItem ? setFunnelItemLabel(fieldName)(funnelItem) : funnelItem),
            (funnelItem) => (funnelItem ? setFunnelItemLabelPrevious(previousMetricField)(funnelItem) : funnelItem),
            (funnelItem) => (funnelItem ? setFunnelItemValueFormatted(isNotEnough)(funnelItem) : funnelItem),
            (funnelItem) =>
                funnelItem
                    ? setFunnelItemFractionPercent(previousMetricValue, firstMetricValue)(funnelItem)
                    : funnelItem,
            (funnelItem) => (funnelItem ? setFunnelItemFractionsPercentFormatted(funnelItem) : funnelItem),
            (funnelItem) => (funnelItem ? isMapEmptyLens.modify(() => isMapEmpty)(funnelItem) : funnelItem),
        ),
    )(dimensionFunnel);
};
